export enum ContrastOption {
  HIGH = 'high',
  NORMAL = 'normal',
  SYSTEM = 'system',
}
